import { useState } from "react";
import { categoryService } from "./categoryService";
import { notifyError, notifySuccess } from "../../../../../assets/toastService";
import { errorHandling } from "src/shared/utils/errorHandling";
import axios from "axios";

export const useCategoryActions = () => {
  const [loading, setLoading] = useState(false);

  const createCategory = async (categoryData: { categoryName: string; type: string }) => {
    setLoading(true);

    try {
      const data = await categoryService.create(categoryData);

      notifySuccess("Category added successfully");

      return data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        // errorHandling(error);
      } else {
        notifyError("Something went wrong");
      }

      // Prevent duplicate console red error
      return null;
    } finally {
      setLoading(false);
    }
  };

  const updateCategory = async (
    id: string,
    categoryData: { categoryName: string; type?: string }
  ) => {
    setLoading(true);

    try {
      const data = await categoryService.update(id, categoryData);

      notifySuccess("Category updated successfully");

      return data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        errorHandling(error);
      } else {
        notifyError("Something went wrong");
      }

      return null;
    } finally {
      setLoading(false);
    }
  };

  const deleteCategory = async (id: string) => {
    setLoading(true);

    try {
      const data = await categoryService.delete(id);

      notifySuccess("Category deleted successfully");

      return data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        errorHandling(error);
      } else {
        notifyError("Failed to delete category");
      }

      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    createCategory,
    updateCategory,
    deleteCategory,
  };
};